import { render } from "./productdetails.vue?vue&type=template&id=3b00c532&scoped=true"
import script from "./productdetails.vue?vue&type=script&lang=js"
export * from "./productdetails.vue?vue&type=script&lang=js"

import "./productdetails.vue?vue&type=style&index=0&id=3b00c532&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b00c532"]])

export default __exports__